import logo from './style/header.png';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Fragment, useEffect, useState} from 'react';
import CoursesFilter from './CoursesFilter';
import './style/Courses.css';
import CoursesList from './CoursesList';
import {getCoursesList} from './Courses.service';
import {courseProvider} from './interfaces/ICourses';
import {Enums} from '../../helpers/Enums';

const Courses = () => {
  const [page, setPage] = useState<number>(1);
  const [title, setTitle] = useState<string>('');
  const courseProvider: courseProvider[] = [
    {id: 0, name: Enums.Nurabi},
    {id: 1, name: Enums.Consultants},
    {id: 2, name: Enums.teachers},
    {id: 3, name: Enums.Coaches},
  ];
  const [learnType, setLearnType] = useState<string[]>([]);
  const [categoriesSelected, setCategoriesSelected] = useState<number[]>([]);
  const [languagesSelected, setLanguagesSelected] = useState<number[]>([]);
  const [courseProviderSelected, setCourseProviderSelected] = useState<
    number[]
  >([]);
  const [pricing, setPricing] = useState<string[]>([]);

  useEffect(() => {
    getCourses();
  }, [
    learnType,
    categoriesSelected,
    languagesSelected,
    pricing,
    courseProviderSelected,
    page,
    title,
  ]);

  const getCourses = () => {
    getCoursesList({
      page: page,
      load: false,
      learnType: learnType,
      title: title,
      language: languagesSelected,
      categories: categoriesSelected,
      courseProvider: courseProviderSelected,
      price: pricing,
    });
  };
  return (
    <div>
      <Fragment>
        <div className="header">
          <Container>
            <Row className="d-flex justify-content-between">
              <Col xs={6} className="d-flex">
                <div className="breadcrumb d-flex justify-content-center">
                  <h3 className="breadcrumb-header">Courses</h3>
                  <div className="breadcrumb-details">
                    <span>Home</span> <span> - </span>{' '}
                    <span className="active-page">Courses</span>
                  </div>
                </div>
              </Col>

              <Col xs={6}>
                <img src={logo} alt="courses" className='mobile-hidden' />
              </Col>
            </Row>
          </Container>
        </div>

        <div className="content-details">
          <Container>
            <Row className="d-flex justify-content-between">
              <CoursesFilter
                setLearnType={setLearnType}
                learnType={learnType}
                setCategoriesSelected={setCategoriesSelected}
                categoriesSelected={categoriesSelected}
                setLanguagesSelected={setLanguagesSelected}
                languagesSelected={languagesSelected}
                setCourseProviderSelected={setCourseProviderSelected}
                courseProviderSelected={courseProviderSelected}
                setPricing={setPricing}
                pricing={pricing}
                courseProvider={courseProvider}
                setPage={setPage}
              />

              <Col md={9}>
                <CoursesList
                  setPage={setPage}
                  page={page}
                  submitTitle={setTitle}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </Fragment>
    </div>
  );
};

export default Courses;
